import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'ConsumableOverview',
  //   description: 'description of ConsumableOverview',
  //   url: '/consumable-overview',
  // },
];

export default help;
